import { render, staticRenderFns } from "./TextareaInput.vue?vue&type=template&id=0e376146&"
import script from "./TextareaInput.vue?vue&type=script&lang=ts&"
export * from "./TextareaInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports